import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Invoices_ds_operation_codes_ddService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { id?: number[], fullTextSearch?: string, operationTypeId?: number[] }): 
  Promise<{ result: { Id?: number, BillingCodeId?: number, Description?: string, Name?: string, OperationTypeId?: number, StandardCost?: number, StandardRate?: number, Uom?: number, OperationType?: { Name?: string } }[] }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { id?: number[], fullTextSearch?: string, operationTypeId?: number[], $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, BillingCodeId?: number, Description?: string, Name?: string, OperationTypeId?: number, StandardCost?: number, StandardRate?: number, Uom?: number, OperationType?: { Name?: string } }[], totalCount: number }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { id?: number[], fullTextSearch?: string, operationTypeId?: number[], $keys: number[] }): 
  Promise<{ result: { Id?: number, BillingCodeId?: number, Description?: string, Name?: string, OperationTypeId?: number, StandardCost?: number, StandardRate?: number, Uom?: number, OperationType?: { Name?: string } }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      id?: number[], fullTextSearch?: string, operationTypeId?: number[]    }) {
      return false;
    }
}
